import { moneyAmountLabel } from '@/utils/formatCurrency';

type AdGroupFieldsProps = {
  adGroupName: string;
  onAdGroupNameChange: (value: string) => void;
  onAdGroupNameBlur?: () => void;
  defaultBid?: string;
  onDefaultBidChange?: (value: string) => void;
  showDefaultBid?: boolean;
  bidOptimization?: string;
  onBidOptimizationChange?: (value: string) => void;
  showSdFields?: boolean;
  creativeType?: string;
  onCreativeTypeChange?: (value: string) => void;
  disabled?: boolean;
};

export function AdGroupFields({
  adGroupName,
  onAdGroupNameChange,
  onAdGroupNameBlur,
  defaultBid = '1',
  onDefaultBidChange,
  showDefaultBid = false,
  bidOptimization = 'clicks',
  onBidOptimizationChange,
  showSdFields = false,
  creativeType = 'IMAGE',
  onCreativeTypeChange,
  disabled = false,
}: AdGroupFieldsProps) {
  return (
    <fieldset className="border border-border rounded-xl p-4 space-y-3">
      <legend className="text-sm font-medium text-foreground-muted px-1">Ad group</legend>
      <div>
        <label className="block text-sm font-medium text-foreground-muted mb-1">Ad group name</label>
        <input
          type="text"
          value={adGroupName}
          onChange={(e) => onAdGroupNameChange(e.target.value)}
          onBlur={onAdGroupNameBlur}
          className="w-full border border-border rounded-lg px-3 py-2"
          disabled={disabled}
          placeholder="e.g. Spring manual search - Ad Group"
        />
      </div>
      {showDefaultBid && onDefaultBidChange && (
        <div>
          <label className="block text-sm font-medium text-foreground-muted mb-1">{moneyAmountLabel('Default bid')}</label>
          <input
            type="number"
            step="0.01"
            min="0.01"
            value={defaultBid}
            onChange={(e) => onDefaultBidChange(e.target.value)}
            className="w-full border border-border rounded-lg px-3 py-2"
            disabled={disabled}
          />
        </div>
      )}
      {showSdFields && onBidOptimizationChange && onCreativeTypeChange && (
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-sm font-medium text-foreground-muted mb-1">Bid optimization</label>
            <select
              value={bidOptimization}
              onChange={(e) => onBidOptimizationChange(e.target.value)}
              className="w-full border border-border rounded-lg px-3 py-2 text-sm"
              disabled={disabled}
            >
              <option value="clicks">Clicks</option>
              <option value="conversions">Conversions</option>
              <option value="reach">Reach</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground-muted mb-1">Creative type</label>
            <select
              value={creativeType}
              onChange={(e) => onCreativeTypeChange(e.target.value)}
              className="w-full border border-border rounded-lg px-3 py-2 text-sm"
              disabled={disabled}
            >
              <option value="IMAGE">Image</option>
              <option value="VIDEO">Video</option>
            </select>
          </div>
        </div>
      )}
    </fieldset>
  );
}
